import { notifier, TOASTER_AUTO_CLOSE } from 'components/Toaster';
import { useEffect, useRef } from 'react';

function useToaster(isLoading, { type = 'info', message, isFile } = {}) {
  const toaster = useRef(null);

  useEffect(() => {
    if (isLoading && !toaster.current) toaster.current = notifier.loading('Updating...');
    if (!isLoading && toaster.current) {
      notifier.update(toaster.current, {
        type,
        autoClose: true,
        isLoading: false,
        render:
          message ?? type === 'error'
            ? 'Error occurred!'
            : isFile
            ? 'File(s) uploaded successfully'
            : 'Record(s) updated successfully',
      });
      toaster.current = null;
    }

    return () => {
      setTimeout(() => {
        notifier.dismiss();
      }, TOASTER_AUTO_CLOSE);
    };
  }, [isFile, isLoading, message, type]);

  return toaster;
}

export default useToaster;
